import { IProject } from '../interfaces/interfaces';
import ECommerceImage from '../assets/images/ecommerce.png';
import ECommerceImage1 from '../assets/images/ecommerce1.png';
import ECommerceImage2 from '../assets/images/ecommerce2.png';
import ECommerceImage3 from '../assets/images/ecommerce3.png';
import ECommerceImage4 from '../assets/images/ecommerce4.png';
import TennisMachesImage from '../assets/images/tennis.png';
import TennisMachesImage1 from '../assets/images/tennis1.png';
import TennisMachesImage2 from '../assets/images/tennis2.png';
import NoImageImage from '../assets/images/no-image.png';

export const projects: IProject[] = [
    {
        name: 'E-Commerce Platform',
        year: '2023',
        role: 'Full-stack · solo',
        featured: true,
        images: [
            { image: ECommerceImage, default: true },
            { image: ECommerceImage1, default: false },
            { image: ECommerceImage2, default: false },
            { image: ECommerceImage3, default: false },
            { image: ECommerceImage4, default: false },
        ],
        tech: ['React', 'TypeScript', 'MobX', 'MongoDB', 'Express', 'Twilio', 'Vercel'],
        description:
            'A storefront and admin suite built end to end — catalogue, cart, checkout and order management, with SMS notifications and a layout tuned separately for mobile and desktop.',
    },
    {
        name: 'Tennis Matches',
        year: '2022',
        role: 'Full-stack · solo',
        featured: true,
        images: [
            { image: TennisMachesImage, default: true },
            { image: TennisMachesImage1, default: false },
            { image: TennisMachesImage2, default: false },
        ],
        tech: ['React', 'Redux', 'MySQL', 'Express', 'PlanetScale', 'Vercel'],
        description:
            'A web app for players to record match scores against opponents and track results over time, backed by a relational schema for players, matches and sets.',
    },
    {
        name: 'Restaurant Orders App',
        badge: 'Graduation project',
        year: '2020',
        role: 'Mobile · full-stack',
        featured: false,
        images: [{ image: NoImageImage, default: true }],
        tech: ['React Native', 'MongoDB', 'Express', 'Twilio', 'Heroku'],
        description:
            'A mobile ordering app covering delivery and self-pickup, with multiple restaurant menus, navigation and contact flows, plus SMS order confirmation.',
    },
];

export const featuredProjects = projects.filter((project) => project.featured);
